<h1 mat-dialog-title>Share Link</h1>

<div mat-dialog-content class="dialog-content">
    <div *ngIf="!isLoading && !generatedLink">
        <p>
            Generate a read-only share link for
            <strong>{{ data.venueName }}</strong>
            (from {{ data.dateStart.format('DD/MM/YYYY')}} to {{ data.dateEnd.format('DD/MM/YYYY') }}).
        </p>
        <p>This will create a link you can share with users, even if they don't have an account.</p>

        <div *ngIf="errorMessage" class="error-container">
            <mat-icon color="warn">warning</mat-icon>
            <span>{{ errorMessage }}</span>
        </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Generating your link...</p>
    </div>

    <div *ngIf="!isLoading && generatedLink">
        <p>Share this link with anyone. They won't need an account to view it.</p>
        <mat-form-field appearance="outline" class="link-field">
            <mat-label>Shareable Link</mat-label>
            <input matInput readonly [value]="generatedLink">
            <button mat-icon-button matSuffix (click)="onCopyLink()" [attr.aria-label]="'Copy link'">
                <mat-icon>{{ isCopied ? 'check' : 'content_copy' }}</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">Close</button>
    <button
            *ngIf="!isLoading && !generatedLink"
            mat-raised-button
            color="primary"
            (click)="onGenerateLink()"
            cdkFocusInitial>
        Generate Link
    </button>
</div>
